import { l } from './imports'
import { assert } from './assert-sidecar'
import { IMachineData } from '../machines/machinesData'

export function t(condition: boolean, ...error: string[]): asserts condition {
  if (!condition) {
    let message = ['ERROR assert failed', ...error]
    console.error(...message)
    throw new Error(l.join(message, ' | '))
  }
}
export function f(
  condition: boolean,
  ...error: string[]
): asserts condition is false {
  t(!condition, ...error)
}
export function nil(
  item: any,
  ...error: string[]
): asserts item is null | undefined {
  t(item === null || item === undefined, 'nil', ...error)
}
export function notNil(item: any, ...error: string[]): asserts item {
  t(item !== null && item !== undefined, 'notNil', ...error)
}

export function onlyOneIsNotNil(a: any, b: any, ...error: string[]) {
  assert.f(a == null && b == null, 'both nil', ...error)
  assert.f(a != null && b != null, 'both not nil', ...error)
}

export function notIn(array: any[], item: any, ...error: string[]) {
  t(!l.includes(array, item), 'notIn', ...error)
}

export function isIn(array: any[], item: any, ...error: string[]) {
  t(l.includes(array, item), 'isIn', ...error)
}
export function eq(a: any, b: any, ...error: string[]) {
  t(a === b, 'eq', ...error)
}
